
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.532 1.252a.5.5 0 01.936 0l1.144 3.06a.5.5 0 00.447.324l3.263.143a.5.5 0 01.289.89l-2.556 2.034a.5.5 0 00-.17.524l.872 3.148a.5.5 0 01-.758.55l-2.723-1.802a.5.5 0 00-.552 0l-2.723 1.802a.5.5 0 01-.758-.55l.872-3.148a.5.5 0 00-.17-.525L1.389 5.67a.5.5 0 01.29-.89l3.262-.143a.5.5 0 00.447-.324l1.144-3.06z","stroke":"currentColor"}})])
          )
        }
      }
    